module.exports = __webpack_public_path__ + "static/media/large-text-transparent.a9dc1a3b.png";